<script>
	let { class: className = '', ...props } = $props();
</script>

<svg class={className} fill="none" preserveAspectRatio="none" viewBox="0 0 123 123" {...props}>
	<g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3">
		<path
			d="M107.225 28.04a58.2 58.2 0 0 1 11.519 34.825c0 32.363-26.263 58.584-58.605 58.584S1.555 95.228 1.555 62.865 27.797 4.26 60.139 4.26a58.2 58.2 0 0 1 34.844 11.518"
		/>
		<path
			d="M60.137 102.196c21.722 0 39.331-17.609 39.331-39.331S81.86 23.533 60.137 23.533s-39.332 17.61-39.332 39.332 17.61 39.331 39.332 39.331"
		/>
		<path
			d="M70.16 78.636c8.714-5.538 11.288-17.091 5.75-25.805s-17.092-11.287-25.805-5.749-11.287 17.091-5.75 25.805c5.54 8.713 17.092 11.287 25.806 5.749"
		/>
		<path d="M109.209 13.814h12.242l-15.075 15.075H94.113L69.07 53.93" />
		<path d="M109.205 13.814V1.55L94.109 16.647v12.242L60.133 62.865" />
	</g>
</svg>
